'use client'

import UIText from '@components/ui/UIText'
import { LevelType } from '@components/ui/UIText/UITextRoot'
import { useArticleSizeControl } from '@store/articleSize'
import { ElementType, ReactNode } from 'react'
import { pretendard } from '@ui/style/muiTheme'

const ArticleText = ({ component, children }: { component?: string; children: ReactNode }) => {
	const { articleSize } = useArticleSizeControl()
	const notEmpty = typeof children !== 'string' || children.trim() !== ''
	return (
		notEmpty && (
			<UIText
				component={(component ?? 'span') as ElementType}
				level={`ArticleBody${articleSize}` as LevelType}
				sx={{
					'&': {
						display: 'inline',
					},
					'& b, & strong': { fontWeight: 700 },
					'& i': { fontStyle: 'italic' },
					'& u': { textDecoration: 'underline', textUnderlineOffset: '.175em' },
					'& *:not(.caption)': {
						fontSize: 'inherit!important',
						lineHeight: 'inherit!important',
					},
				}}
			>
				{children}
			</UIText>
		)
	)
}

export default ArticleText
